// used by JSONNode during dragging
export const singleton = {
  selecting: false,
  selectionAnchor: null, // Path
  selectionAnchorType: null, // Selection type
  selectionFocus: null, // Path

  dragging: false
}
